import React from 'react';
import PropTypes from 'prop-types';

export default class Row extends React.Component {
    _getTextColourStyle = key => {
      const { sortedBy } = this.props;

      if (sortedBy === key) return 'active';
      return '';
    };

  _getComponentReadableStatus = () => {
    const {component} = this.props;

    if (component && component.applicationStatus) {
      return component.applicationStatus[0].toUpperCase() + component.applicationStatus.slice(1).toLowerCase();
    }

    return '';
  };

  render() {
    const {component, selectComponentForDeletion, deleteSingleComponent} = this.props;

    return (
      <div id={`componentListRowID${component.id}`} className='list__row list__row_small'>
        <div className='list__row-item list__row-item_small list__row-item_component _width_pc_8'>
          <div
            className={`${component.checked ? '__checkbox_checked' : '__checkbox_empty'} _cursor_pointer`}
            onClick={selectComponentForDeletion(component)}
          />
        </div>

        <div
          id='componentIDField'
          className={`list__row-item list__row-item_small ${this._getTextColourStyle('id')} _width_pc_12`}
        >
          {component.id}
        </div>

        <div
          id='componentDescriptionField'
          className={`list__row-item list__row-item_small ${this._getTextColourStyle(
            'description'
          )} list__row-item_place-filler`}
        >
          {component.description}
        </div>

        <div className='list__row-item list__row-item_small _width_pc_18'>
          <div
            id='componentStatusField'
            className={`list__status-label_small list__status-label_${component.applicationStatus.toLowerCase()} ${this._getTextColourStyle(
              'applicationStatus'
            )}`}
          >
            {this._getComponentReadableStatus()}
          </div>
        </div>

        <div className='list__row-item list__row-item_small _width_pc_12'>
          <div
            className='__remove-icon'
            onClick={() => {
              deleteSingleComponent(component);
            }}
          />
        </div>
      </div>
    );
  }
}

Row.propTypes = {
  component: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Edit/ComponentList/Row.jsx